import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';

export const MuiDrawer = {
  styleOverrides: {
    paper: {
      width: 280,
      backgroundColor: 'var(--mui-palette-background-paper)',
      backgroundImage: 'none',
      borderRadius: 0,
    },
    paperAnchorLeft: ({ theme }) => ({
      borderRight: `1px solid ${
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.12)'
          : 'rgba(0, 0, 0, 0.06)'
      }`,
    }),
    paperAnchorRight: ({ theme }) => ({
      borderLeft: `1px solid ${
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.12)'
          : 'rgba(0, 0, 0, 0.06)'
      }`,
    }),
    paperAnchorTop: ({ theme }) => ({
      borderBottom: `1px solid ${
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.12)'
          : 'rgba(0, 0, 0, 0.06)'
      }`,
    }),
    paperAnchorBottom: ({ theme }) => ({
      borderTop: `1px solid ${
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.12)'
          : 'rgba(0, 0, 0, 0.06)'
      }`,
    }),
    modal: {
      // Backdrop styling for temporary drawer
      '& .MuiBackdrop-root': {
        backgroundColor: 'var(--mui-palette-Backdrop-bg)',
      },
    },
  },
} satisfies Components<Theme>['MuiDrawer'];
